// Staff copy for the Screen apps page (admin/ScreenApps.tsx) and the "Screen app"
// placement (admin/equipment/ScreenAppSection.tsx, lib/screenApps.ts), in the three
// languages a branch in Azerbaijan works in.
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const screenApps = {
  'admin.section.screenApps': { en: 'Screen apps', az: 'Ekran tətbiqləri', ru: 'Экранные приложения' },

  'screenApps.saveApp': { en: 'Save the app', az: 'Tətbiqi yadda saxla', ru: 'Сохранить приложение' },
  'screenApps.uploading': { en: 'Uploading…', az: 'Yüklənir…', ru: 'Загрузка…' },
  'screenApps.none': { en: 'No apps uploaded yet.', az: 'Hələ heç bir tətbiq yüklənməyib.', ru: 'Приложения пока не загружены.' },

  'screenApps.placedOn': {
    en: '{n} machine runs it.|{n} machines run it.',
    az: '{n} cihazda işləyir.',
    ru: 'Работает на {n} устройстве.|Работает на {n} устройствах.|Работает на {n} устройствах.',
  },
  'screenApps.version': { en: 'Version', az: 'Versiya', ru: 'Версия' },
  'screenApps.uploadedAt': { en: 'Uploaded', az: 'Yükləndi', ru: 'Загружено' },
  'screenApps.sha': { en: 'Checksum', az: 'Yoxlama cəmi', ru: 'Контрольная сумма' },
  'screenApps.current': { en: 'Current', az: 'Cari', ru: 'Текущая' },
  'screenApps.makeCurrent': { en: 'Make current', az: 'Cari et', ru: 'Сделать текущей' },

  'screenApps.retire': { en: 'Retire', az: 'İstifadədən çıxar', ru: 'Вывести из работы' },

  'screenApps.preview': { en: 'Preview', az: 'Önizləmə', ru: 'Предпросмотр' },

  'screenApps.pick': { en: 'Screen app', az: 'Ekran tətbiqi', ru: 'Экранное приложение' },
  'screenApps.design': { en: 'None (the design)', az: 'Heç biri (dizayn)', ru: 'Ничего (макет)' },
  'screenApps.placedApp': { en: 'This machine now runs {name}.', az: 'Bu cihaz indi {name} tətbiqini işlədir.', ru: 'Это устройство теперь показывает {name}.' },
  'screenApps.placedDesign': { en: 'This machine now runs its own design again.', az: 'Bu cihaz yenidən öz dizaynını işlədir.', ru: 'Это устройство снова показывает собственный макет.' },

  'screenApps.moduleOffHint': {
    en: "This organisation's licence no longer includes screen apps, so nothing else can be chosen here — only taken off.",
    az: 'Bu təşkilatın lisenziyasına artıq ekran tətbiqləri daxil deyil, ona görə burada başqa heç nə seçilə bilməz — yalnız götürülə bilər.',
    ru: 'Лицензия этой организации больше не включает экранные приложения, поэтому здесь больше ничего нельзя выбрать — только снять.',
  },
  'screenApps.takeOff': { en: 'Take the app off', az: 'Tətbiqi götür', ru: 'Снять приложение' },
  'screenApps.badInteger': {
    en: '{name} needs a whole number.',
    az: '{name} tam ədəd tələb edir.',
    ru: '«{name}» должно быть целым числом.',
  },
  // P10b part C: the Connectors page (admin/Connectors.tsx, lib/connectors.ts).
  // Added at the end, and no key above changed, so that this file merges with
  // the Screen apps page's own wording as it moves.
  'admin.section.connectors': { en: 'Connectors', az: 'Konnektorlar', ru: 'Коннекторы' },
  'connectors.none': { en: 'No connectors yet.', az: 'Hələ heç bir konnektor yoxdur.', ru: 'Коннекторов пока нет.' },
  'connectors.add': { en: 'New connector', az: 'Yeni konnektor', ru: 'Новый коннектор' },
  'connectors.name': { en: 'Name', az: 'Ad', ru: 'Название' },
  'connectors.url': { en: 'Address', az: 'Ünvan', ru: 'Адрес' },
  'connectors.methods': { en: 'Methods', az: 'Metodlar', ru: 'Методы' },
  'connectors.headerName': { en: 'Header for the secret', az: 'Gizli açar üçün başlıq', ru: 'Заголовок для секрета' },
  'connectors.timeout': { en: 'Time limit (ms)', az: 'Vaxt həddi (ms)', ru: 'Лимит времени (мс)' },
  'connectors.secret': { en: 'Secret', az: 'Gizli açar', ru: 'Секрет' },
  'connectors.secretOptional': { en: 'Secret (optional)', az: 'Gizli açar (istəyə görə)', ru: 'Секрет (необязательно)' },
  'connectors.noSecret': { en: 'No secret', az: 'Gizli açar yoxdur', ru: 'Секрета нет' },
  'connectors.setSecret': { en: 'Set the secret', az: 'Gizli açarı təyin et', ru: 'Задать секрет' },
  'connectors.recentCalls': { en: 'Recent calls', az: 'Son çağırışlar', ru: 'Последние вызовы' },
  'connectors.recentCallsHint': {
    en: 'The last 50, kept for 30 days. What was sent and answered is never kept.',
    az: 'Son 50 çağırış, 30 gün saxlanılır. Göndərilən və cavab verilən məzmun heç vaxt saxlanılmır.',
    ru: 'Последние 50, хранятся 30 дней. Отправленное и полученное содержимое не сохраняется.',
  },
  'connectors.noCalls': { en: 'No calls yet.', az: 'Hələ çağırış yoxdur.', ru: 'Вызовов пока нет.' },
  'connectors.col.time': { en: 'Time', az: 'Vaxt', ru: 'Время' },
  'connectors.col.machine': { en: 'Machine', az: 'Cihaz', ru: 'Устройство' },
  'connectors.col.method': { en: 'Method', az: 'Metod', ru: 'Метод' },
  'connectors.col.status': { en: 'Status', az: 'Status', ru: 'Статус' },
  'connectors.col.outcome': { en: 'Outcome', az: 'Nəticə', ru: 'Результат' },
  'connectors.noAnswer': { en: 'none', az: 'yoxdur', ru: 'нет' },
  'connectors.machineGone': { en: 'a machine no longer here', az: 'artıq olmayan cihaz', ru: 'устройство, которого больше нет' },
  'connectors.outcome.ok': { en: 'Answered', az: 'Cavab verildi', ru: 'Ответ получен' },
  'connectors.outcome.http_error': { en: 'Answered with an error', az: 'Xəta ilə cavab verildi', ru: 'Ответ с ошибкой' },
  'connectors.outcome.timeout': { en: 'Too slow', az: 'Çox gecikdi', ru: 'Слишком долго' },
  'connectors.outcome.refused_address': {
    en: 'Address refused by this server',
    az: 'Ünvan bu server tərəfindən rədd edildi',
    ru: 'Адрес отклонён этим сервером',
  },
  'connectors.outcome.unreachable': { en: 'Could not be reached', az: 'Əlçatmaz idi', ru: 'Недоступен' },
  'connectors.outcome.cancelled': { en: 'The machine stopped waiting', az: 'Cihaz gözləməyi dayandırdı', ru: 'Устройство перестало ждать' },
  'connectors.outcome.too_large': { en: 'Answer over 256 KB', az: 'Cavab 256 KB-dan böyükdür', ru: 'Ответ больше 256 КБ' },
  'connectors.problem.name': {
    en: 'The name must be lower-case letters, digits and -, start with a letter or digit, and be at most 40 characters.',
    az: 'Ad kiçik hərflər, rəqəmlər və - işarəsindən ibarət olmalı, hərf və ya rəqəmlə başlamalı və ən çoxu 40 simvol olmalıdır.',
    ru: 'Название должно состоять из строчных букв, цифр и -, начинаться с буквы или цифры и быть не длиннее 40 символов.',
  },
  'connectors.problem.url': {
    en: 'The address must start with https:// or http:// and name a server.',
    az: 'Ünvan https:// və ya http:// ilə başlamalı və serveri göstərməlidir.',
    ru: 'Адрес должен начинаться с https:// или http:// и указывать сервер.',
  },
  'connectors.problem.urlLong': { en: 'The address is longer than 2048 characters.', az: 'Ünvan 2048 simvoldan uzundur.', ru: 'Адрес длиннее 2048 символов.' },
  'connectors.problem.password': {
    en: 'Put no user name or password in the address: the secret is what the header is for.',
    az: 'Ünvana istifadəçi adı və ya şifrə yazmayın: bunun üçün gizli açar və başlıq var.',
    ru: 'Не указывайте в адресе имя пользователя или пароль: для этого есть секрет и заголовок.',
  },
  'connectors.problem.fragment': { en: 'An address with a # part cannot be called.', az: '# hissəsi olan ünvanı çağırmaq olmaz.', ru: 'Адрес с частью после # вызвать нельзя.' },
  'connectors.problem.methods': { en: 'Choose at least one method.', az: 'Ən azı bir metod seçin.', ru: 'Выберите хотя бы один метод.' },
  'connectors.problem.header': {
    en: "The header must be a header's name of at most 64 characters: letters, digits and - with no spaces.",
    az: 'Başlıq ən çoxu 64 simvolluq başlıq adı olmalıdır: boşluqsuz hərflər, rəqəmlər və -.',
    ru: 'Заголовок должен быть именем заголовка не длиннее 64 символов: буквы, цифры и - без пробелов.',
  },
  'connectors.problem.headerReserved': {
    en: 'The server sets that header itself, so the secret cannot be sent in it.',
    az: 'Server bu başlığı özü təyin edir, ona görə gizli açar onda göndərilə bilməz.',
    ru: 'Этот заголовок сервер задаёт сам, поэтому секрет в нём отправить нельзя.',
  },
  'connectors.problem.timeout': {
    en: 'The time limit must be between 500 and 10000 milliseconds.',
    az: 'Vaxt həddi 500 ilə 10000 millisaniyə arasında olmalıdır.',
    ru: 'Лимит времени должен быть от 500 до 10000 миллисекунд.',
  },
  'connectors.problem.secret': {
    en: 'The secret cannot contain a line break or another control character.',
    az: 'Gizli açarda sətir keçidi və ya başqa idarəedici simvol ola bilməz.',
    ru: 'Секрет не может содержать перевод строки или другой управляющий символ.',
  },
  // The Part C review (C-1): allowed paths, and what a connector is exposed to.
  'connectors.paths': { en: 'Allowed paths', az: 'İcazə verilən yollar', ru: 'Разрешённые пути' },
  'connectors.noPaths': { en: 'the address itself only', az: 'yalnız ünvanın özü', ru: 'только сам адрес' },
  'connectors.problem.paths': {
    en: 'These paths cannot be allowed: {paths}. Each starts with /, holds only letters, digits and - . _ ~ : @ + , = between single slashes, and may end in /* (but not be /* alone, and never hold **).',
    az: 'Bu yollara icazə vermək olmaz: {paths}. Hər biri / ilə başlayır, tək slaşlar arasında yalnız hərflər, rəqəmlər və - . _ ~ : @ + , = saxlayır və /* ilə bitə bilər (lakin təkcə /* ola bilməz və heç vaxt ** saxlamaz).',
    ru: 'Эти пути нельзя разрешить: {paths}. Каждый начинается с /, содержит между одиночными косыми чертами только буквы, цифры и - . _ ~ : @ + , = и может оканчиваться на /* (но не быть только /* и никогда не содержать **).',
  },
  'connectors.problem.secretShort': {
    en: 'The secret must be at least 8 characters long.',
    az: 'Gizli açar ən azı 8 simvol olmalıdır.',
    ru: 'Секрет должен быть не короче 8 символов.',
  },
  'connectors.problem.pathsMany': { en: 'A connector may allow at most 50 paths.', az: 'Konnektor ən çoxu 50 yola icazə verə bilər.', ru: 'Коннектор может разрешать не более 50 путей.' },
} satisfies Record<string, Phrase>
